import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TestimonialCard from 'components/common/TestimonialCard';
import CloseIcon from './assets/close.svg';

import './styles/homeModal.scss';

export default class HomeModal extends Component {
  render() {
    const { home, testimonialInfo, closeModal } = this.props;
    return (
      <div className="home-modal">
        <img className="home-modal__close-button"
          onClick={() => closeModal()} src={CloseIcon} alt="Close" />
        <div className="home-modal__contact-info">
          <div className="home-modal__contact-info__title">
            {home.contactEmailTitle}
          </div>
          <div className="home-modal__contact-info__subtitle">
            {home.contactEmailATitle}
          </div>
          <div className="home-modal__contact-info__text">
            <a href="mailto:info@myBlueprint.ca" className="primary">
              info@myBlueprint.ca
            </a>
          </div>
          <div className="home-modal__contact-info__subtitle">
            {home.contactEmailBTitle}
          </div>
          <div className="home-modal__contact-info__text">
            <a href="mailto:support@myBlueprint.ca" className="primary">
              support@myBlueprint.ca
            </a>
          </div>
        </div>
        <div className="home-modal__testimonial">
          {(testimonialInfo.length > 0) &&
            <TestimonialCard info={testimonialInfo[0].fields} />
          }
        </div>
      </div>
    );
  }
}

HomeModal.propTypes = {
  testimonialInfo: PropTypes.array,
  home: PropTypes.object,
  closeModal: PropTypes.func
};
